<template>
  <section class="system">
    <section class="content_section light_sec">
      <h2>全新支付系统</h2>
      <h4>多元化充值渠道</h4>
      <ul class="pay_list">
          <li v-for="(url, idx) in ways" :key="idx">
            <img :src="url">
          </li>
      </ul>
    </section>
    <section class="content_section dark_sec">
      <h4>全方位服务保证</h4>
      <ul class="service_list">
        <li v-for="(url, idx) in services" :key="idx">
          <img :src="url">
        </li>
      </ul>
    </section>
    <section class="content_section blue_sec">
      <h4>支付系统接入流程</h4>
      <ul class="flow_list">
        <li v-for="(item, idx) in flow" :key="idx">
          <div>
            <div class="image"><img :src="item.image"></div>
            <div>
              <h5><span>{{idx + 1}}</span>{{item.title}}</h5>
              <p>{{item.text}}</p>
            </div>
          </div>
          <!-- <img class="flow_arrow" src="../assets/flow_arrow.png"> -->
        </li>
      </ul>
    </section>
  </section>
</template>
<script>
import { systemObj } from '@/utils/page_setting'
const images = require.context('../assets/', false, /\.png$/)

export default {
  name: 'system',
  computed: {
    ways () {
      const wayArr = []
      systemObj.payArr.forEach(item => {
        wayArr.push(images(`./${item}.png`))
      })
      return wayArr
    },
    services () {
      const serviceArr = []
      for (let idx = 1; idx < 6; idx++) {
        serviceArr.push(images(`./promise_0${idx}.png`))
      }
      return serviceArr
    },
    flow () {
      const flowArr = []
      systemObj.flowObj.forEach((item, idx) => {
        flowArr[idx] = item
        flowArr[idx].image = images(`./system_flow_0${idx + 1}.png`)
      })
      return flowArr
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../css/common.less';
  .system{
    display: flex;
    flex-direction: column;
    ul{
      width: max-content;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-content: center;
      align-items: center;
      background-color: transparent;
      &.pay_list{
        margin: 50px auto 0;
        li{
          margin: 0 50px;
          img{
            width: auto;
            height: 60px;
          }
        }
      }
      &.service_list{
        margin: 40px auto 0;
        li{
          margin: 0 17.5px;
          img{
            width: 180px;
            height: auto;
          }
        }
      }
      &.flow_list{
        margin: 30px auto 0;
        align-items: flex-start;
        li{
          display: inline-flex;
          flex-direction: row;
          align-content: top;
          padding: 0 1.2em;
          div{
            width: 146px;
            .image{
              position: relative;
              width: 146px;
              height: 146px;
              img{
                position: relative;
                width: 108%;
                margin-left: -4%;
              }
              &::after{
                content: '';
                display: block;
                position: absolute;
                width: 1.3em;
                height: 1.2em;
                clip-path: polygon(55% 0, 90% 50%, 55% 100%, 20% 100%, 55% 50%, 20% 0);
                background-color: #65a9ff;
                top: calc( 50% - 1.1em );
                right: -1.7em;
              }
            }
            h5{
              color: #0044ff;
              font-size: 1em;
              text-align: justify;
              font-weight: 500;
              line-height: 1.94;
              padding: 0 15px;
              margin: 0;
              span{
                font-size: 1.3em;
                font-weight: bold;
                font-style: italic;
                padding-right: .5em;
              }
            }
            p{
              font-size: 0.89em;
              word-break: break-word;
              text-align: justify;
              padding: 0 10px 0 15px;
              line-height: 1.56;
              margin: 0;
            }
          }
          &:last-child div .image::after{display: none;}
        }
      }
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1050px) {
    .system{
      display: flex;
      flex-direction: column;
      ul{
        width: max-content;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-content: center;
        align-items: center;
        background-color: transparent;
        &.pay_list{
          width: auto;
          margin: 3em auto 2em;
          li{
            margin: 0 .8em;
            img{
              width: auto;
              height: 3.6em;
            }
          }
        }
        &.service_list{
          width: auto;
          margin: 2.5em auto 1em;
          li{
            margin: 0 1em;
            img{
              width: 7em;
              height: auto;
            }
          }
        }
        &.flow_list{
          width: auto;
          margin: 2.2em auto .5em;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;
          li{
            display: inline-flex;
            flex-direction: row;
            padding: 0 2.4em 0 0;
            margin-bottom: 1.8em;
            div{
              width: 9em;
              .image{
                position: relative;
                width: 8em;
                height: 8em;
                img{
                  position: relative;
                  width: 108%;
                  margin-left: -4%;
                }
                &::after{
                  content: '';
                  display: block;
                  position: absolute;
                  width: 1.3em;
                  height: 1.2em;
                  clip-path: polygon(55% 0, 90% 50%, 55% 100%, 20% 100%, 55% 50%, 20% 0);
                  background-color: #65a9ff;
                  top: calc( 50% - 1.1em );
                  right: -2.2em;
                }
              }
              h5{
                color: #0044ff;
                font-size: 1em;
                text-align: justify;
                font-weight: 500;
                line-height: 1.94;
                padding: 0 1em;
                margin: 0;
                span{
                  font-size: 1.3em;
                  font-weight: bold;
                  font-style: italic;
                  padding-right: .3em;
                }
              }
              p{
                font-size: 0.89em;
                word-break: break-word;
                text-align: justify;
                padding: 0 1.5em 0 1em;
                line-height: 1.56;
                margin: 0;
              }
            }
            &:last-child div .image::after{display: none;}
          }
        }
      }
    }
  }
  @media screen and (max-width: 767.9px) {
    .system{
      ul{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        &.pay_list{
          margin: 1.5em auto;
          justify-content: center;
          li{
            display: inline-block;
            width: 6em;
            height: 4em;
            margin: 1em .5em;
            img{
              height: 3em;
            }
          }
        }
        &.service_list{
          width: auto;
          margin: 1.2em auto .8em;
          justify-content: center;
          li{
            margin: .8em;
            img{
              width: 22vw;
              max-width: 6em;
            }
          }
        }
        &.flow_list{
          width: auto;
          margin: 2.2em auto 0;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          li{
            flex-direction: column;
            padding: 0 .5em;
            margin-bottom: 0;
            > div{
              display: inline-flex;
              flex-direction: row;
              justify-content: center;
              align-items: unset;
              width: auto;
              .image{
                position: unset;
                display: flex;
                flex-direction: column;
                width: 7.6em;
                height: auto;
                margin-right: .5em;
                img{
                  width: 100%;
                  margin-left: 0;
                }
                &::after{
                  content: '';
                  display: block;
                  position: unset;
                  width: 1.5em;
                  height: 1.6em;
                  margin: .5em auto 0;
                  clip-path: polygon(55% 0, 90% 50%, 55% 100%, 20% 100%, 55% 50%, 20% 0);
                  background-color: #65a9ff;
                  transform: rotate(90deg);
                }
              }
              div{
                padding: 1em 0;
                h5{
                  color: #0044ff;
                  font-size: 1.1em;
                  text-align: justify;
                  font-weight: 500;
                  line-height: 1.94;
                  padding: 0;
                  margin: 0;
                  span{
                    font-size: 1.3em;
                    font-weight: bold;
                    font-style: italic;
                    padding-right: .25em;
                  }
                }
                p{
                  font-size: 0.9em;
                  word-break: break-word;
                  text-align: justify;
                  padding: 0;
                  line-height: 1.56;
                  margin: 0;
                }
              }
            }
            &:last-child>div .image::after{display: none;}
          }
        }
      }
    }
  }
</style>
